import {
    Box,
    Card,
    CardContent,
    Tabs,
    Tab,
    Skeleton,
    Typography,
} from '@mui/material';
import { useState } from 'react';

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

import { OverviewTab } from './tabs';
import type { NormalizedAssetData } from '../api/asset-tab-types';

interface AssetTabsProps {
    ticker?: string;
    assetType?: string;
    data?: NormalizedAssetData;
    loading?: boolean;
    error?: Error | string | null;
}

export function AssetTabs({ data, loading, error }: AssetTabsProps) {
    const [tabIndex, setTabIndex] = useState(0);

    return (
        <Card>
            <CardContent sx={{ p: 0, '&:last-child': { paddingBottom: 0 } }}>
                <Tabs
                    value={tabIndex}
                    onChange={(_, newValue) => setTabIndex(newValue)}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="scrollable"
                    scrollButtons="auto"
                    sx={{ borderBottom: 1, borderColor: 'divider' }}
                >
                    <Tab
                        icon={<InfoOutlinedIcon />}
                        label="Overview"
                        iconPosition="start"
                        sx={{
                            minHeight: 48,
                            paddingY: 1,
                            textTransform: 'none',
                        }}
                    />
                </Tabs>

                {tabIndex === 0 &&
                    (loading ? (
                        <Box sx={{ p: 2 }}>
                            <Skeleton variant="rounded" height={400} />
                        </Box>
                    ) : error ? (
                        <Typography
                            sx={{
                                color: 'error.main',
                                fontSize: '13px',
                                textAlign: 'center',
                                py: 4,
                            }}
                        >
                            Failed to load asset data
                        </Typography>
                    ) : data ? (
                        <OverviewTab data={data} />
                    ) : null)}
            </CardContent>
        </Card>
    );
}
